document.addEventListener('DOMContentLoaded', (event) => {

  /***********************************************
   * Retrieves a list of posts from the website.
   ***********************************************/

  var $postsInCategory = document.body.querySelectorAll('div.categories-list__category');

  if($postsInCategory !== null) {
    $postsInCategory.forEach( $category => {

      var $categoryUrl = $category.getAttribute('data-url');
      var $showCategory = ($category.getAttribute('data-displaytitle') == 'true');
      var $hideSummary = ($category.getAttribute('data-hidesummary') == 'true');

      // If a slug could be found...
      if($categoryUrl === null) {
        console.log( 'An error occurred when trying to retrieve the external URL to be queried.' );
        return;
      }

      var $categoryResource = fetch($categoryUrl);

      $categoryResource
        .then(function(response) {

          // Tests for response status not desired.
          if (response.status !== 200) {
            console.log('There was an error trying to load the categories from the base website.');
            return;
          }

          // External resource is a JSON file...
          return response.json().then(function(json) {
            var $stringified = JSON.stringify(json);
            var $row = JSON.parse($stringified);

            // Tests if children are available for the resultset.
            if ($row.length > 0 ) {

              // Prepares content output.
              var $content = ``;

              // Gets the category name for the first item and uses it as title, if available.
              if ($showCategory === true && $row[0].hasOwnProperty('categories_names') && $row[0].categories_names.length > 0) {
                $content +=
`
                <h2>${$row[0].categories_names[0]}</h2>
`;
              }

              // Adds list start tag
              $content +=
`
                <ul class="homepage-spotlight__grid direction-vertical">
`;              

              // Goes over each of the categories.
              $row.forEach( $item => {
                if( $item.hasOwnProperty('link') ) {
                  var
                    $link = $item.link,
                    $strDate = ($item.hasOwnProperty('date')) ? $item.date : false,
                    $dateFormatted = false,
                    $title = ($item.hasOwnProperty('title')) ? $item.title['rendered'] : false,
                    $excerpt = ($item.hasOwnProperty('excerpt') && !$hideSummary) ? `<div class="description">${$item.excerpt['rendered']}</div>` : '',
                    $category = ($item.hasOwnProperty('categories')) ? $item.categories[0] : false,
                    $categoryName = ($item.hasOwnProperty('categories_names')) ? $item.categories_names[0] : false;

                  if($strDate !== false) {
                    var $arrDate = $strDate.substr(0,10).split('-');
                    var $dateMonth = [
                      'January',
                      'February',
                      'March',
                      'April',
                      'May',
                      'June',
                      'July',
                      'August',
                      'September',
                      'October',
                      'November',
                      'December'
                    ][$arrDate[1] - 1];
                    $dateFormatted = 
`
                    ${$dateMonth} ${$arrDate[2]} ${$arrDate[0]}
`;
                  }

                  // Gets information on featured image.
                  var $imageContentDiv = '';

                  // Tests if embedded image is available in the first place.
                  if( $item.hasOwnProperty('_embedded') ) {
                    var $imageUrl = $item._embedded['wp:featuredmedia']['0'].source_url;
                    if( $imageUrl !== undefined ) {
                      $imageContentDiv = 
`
                      <div class="content-wrapper__image img-background" style="background-image: url('${$imageUrl}')"><a href="${$link}" title="Read more about product ${$title}"></a></div>
`;
                    }
                  }

                  $content +=
`
                  <li class="grid-item">
                    <div class="image-wrapper">
                      ${$imageContentDiv}
                    </div>
                    <div class="content-wrapper">
                      <div class="intro"><span class="category-name category-id--${$category}">${$categoryName}</span> | ${$dateFormatted}</div>
                      <h3><a href="${$link}" title="Read more about product ${$title}">${$title}</a></h3>
                      ${$excerpt}
                      <div class="additional">
                        <div class="price">
                          <a class="link-read" href="${$link}" title="Read more about product ${$title}">Read More →</a>
                        </div>
                      </div>
                    </div>
                  </li>
`;
                }
              });

              // Closes the menu markup;
              $content +=
`
                </ul>
`
            }

            $category.innerHTML = $content;
          })
          .catch(function(e) {
            console.log(e);
            console.log('There was an issue reading the JSON response for the website stories.')
          });
        })
        .catch(function() {
          console.log( 'An error occurred when trying to load the content for the popup' );
        }
      );

    });
  }

    /***********************************************
   * Retrieves a single post from the website.
   ***********************************************/

  var $externalContentSingle = document.body.querySelector('div.external-content--single-post');

  if($externalContentSingle !== null) {
    var $dataUrl = $externalContentSingle.getAttribute('data-url');
    var $dataDisplayImage = $externalContentSingle.getAttribute('data-image') == 'true';

    // If a slug could be found...
    if($dataUrl === null) {
      console.log( 'An error occurred when trying to retrieve the external URL to be queried.' );
      return;
    }

    var $externalContentResource = fetch($dataUrl);

    $externalContentResource.then(function($response) {

      // Tests for response status not desired.
      if ($response.status !== 200) {
        console.log('There was an error when trying to load external content; response code was not 200.');
        return;
      }

      // External $resource is a JSON file...
      return $response.json().then(function(json) {
        var $stringified = JSON.stringify(json);
        var $item = JSON.parse($stringified);

        var
          $title = ($item.hasOwnProperty('title')) ? $item.title['rendered'] : false,
          $postContent = ($item.hasOwnProperty('content')) ? $item.content['rendered'] : false,
          $imageContentDiv = '',
          $content =
`
<div class="external-content__content">
  <h3 class="section-title">${$title}</h3>
  <div class="description">
    ${$postContent}
  </div>
</div>
`;

        // Tests the availability of an image.
        if($item.hasOwnProperty('_embedded')) {
          console.log('It has its own property');
        }
        if( $dataDisplayImage === true && $item.hasOwnProperty('_embedded') ) {
          var $imageUrl = $item._embedded['wp:featuredmedia']['0'].source_url;
          if( $imageUrl !== undefined ) {
            $imageContentDiv = 
`
<div class="external-content__image content-wrapper__image img-background" style="background-image: url('${$imageUrl}')"></div>
`;
          }
        }

        // Sets innerHTML for the current component.
        $externalContentSingle.innerHTML = $imageContentDiv
        $externalContentSingle.innerHTML += $content;

      })
      .catch(function(e) {
        console.log(e);
        console.log('There was an issue reading the JSON response for the website stories.')
      });
    })
    .catch(function() {
      console.log( 'An error occurred when trying to load the content for the popup' );
    });
  }

});